import {autobind} from 'core-decorators';

import {CustomComponent, Tooltip} from '../components';
import dialog from '../dialog';
import {window} from '../util';


export class TrashIcon extends CustomComponent {
    @autobind
    handleClick(event: Event) {
        const gettextSub = this.context.gtService.gettextSub;

        this.context.apiService.registerEvent('content_delete_button_tap', {}, true);
        dialog.open('confirmation-dialog', {
            header: gettextSub('Confirm Delete'),
            message: gettextSub('Are you sure you want to delete this content? It will no longer be available on Tenor.'),
            confirmButtonText: gettextSub('Yes'),
            confirmCallback: this.confirmCallback,
            denyButtonText: gettextSub('No'),
            denyCallback: this.denyCallback,
        });
    }

    @autobind
    confirmCallback() {
        const gif = this.props.gif;
        this.context.apiService.registerEvent('content_delete_dialog_yes_tap', {}, true);
        this.context.apiService.removeGif(gif).then(() => {
            // Put this before redirect to avoid cached data on next page load
            this.context.store.clearDataSource('api.gifs.searchByUsername.*');
            this.context.store.clearDataSource('api.memes.searchByUsername.*');
            this.context.store.clearDataSource('api.stickers.searchByUsername.*');
            this.redirect(this.linkToProfile(
                this.context.authService.getUsername()));
            // Put this after redirecto to avoid 404 flashing on screen
            this.context.store.refresh('api.gifs.byId.*', [gif.id]);
            window.gaEvent({
                category: 'TrashIcon',
                action: 'click',
                label: gif.id,
            });
        });
    }

    @autobind
    denyCallback() {
        this.context.apiService.registerEvent('content_delete_dialog_no_tap', {}, true);
    }

    render() {
        const gettextSub = this.context.gtService.gettextSub;
        // Translators: alt img text for a trash icon. This icon is used to
        // Translators: allow users to delete their own gif.
        const altText = gettextSub('trash icon', 'Translators: a comment');
        return (
            <span className="TrashIcon" onClick={this.handleClick}>
                <Tooltip
                    hoverMsg={gettextSub('Delete')}
                />
                <img
                    src={`/assets/img/icons/trash.svg`}
                    alt={altText}
                />
            </span>
        );
    }
}
